import * as React from 'react'
import { SVGProps } from 'react'

export const GoogleTagManagerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 25"
    width={props.width ?? 16}
    height={props.height ?? 16}
    fill="none"
    {...props}
  >
    <path fill="#8AB4F8" d="M14.046 23.061 9.962 19.08l8.77-8.955 4.228 4.143-8.914 8.794Z" />
    <path
      fill="#4285F4"
      d="M14.063 5.457 9.995 1.303l-8.897 8.812a2.938 2.938 0 0 0 0 4.154l8.763 8.82 4.143-3.876-6.676-7.02 6.735-6.736Z"
    />
    <path
      fill="#8AB4F8"
      d="M22.9 10.183 14.08 1.36A2.94 2.94 0 0 0 9.92 5.52l8.822 8.822a2.94 2.94 0 0 0 4.159-4.158Z"
    />
    <path fill="#246FDB" d="M11.933 24.025a2.874 2.874 0 1 0 0-5.748 2.874 2.874 0 0 0 0 5.748Z" />
  </svg>
)
